<app-header (handleGoBackButton)="handleGoBack()"></app-header>

<div class="container">
  <div class="content">
    <button *ngIf="!(isMinorThanTablet | async).matches" (click)="handleGoBack()" class="link-btn">
      <mat-icon>arrow_back</mat-icon>
      <span>Voltar</span>
    </button>
    <div class="alert">
      <app-alert [dense]="true" [hideIcon]="true" [type]="'info'" [title]="'Recuperar minha senha'">
      </app-alert>
    </div>
    <app-verification-method [userInfo]="userRecoveryInfo" (methodSelection)="selectVerificationMethod($event)" ></app-verification-method>
  </div>

  <footer class="mobile-footer">
    <span>
      <svg width="13" height="16" xmlns="http://www.w3.org/2000/svg">
        <use xlink:href="/assets/images/icons/ic-security-lock.svg#lock" fill="inherit" />
      </svg>
      Ambiente 100% seguro
    </span>
  </footer>
</div>
